@if (UserVM$ | async; as vm) {
  <div class="kyc-verification">
    <div class="kyc-verification-intro-text">{{ "fma_kyc_please_review" | translate }}</div>
    <div class="separator"></div>
    <div class="kyc-verification-personal-details">
      <div class="kyc-verification-content">
        <div class="kyc-verification-section-titles">{{ "personal_details_title" | translate }}</div>
        <div class="kyc-verification-name">
          <div class="kyc-placeholders">{{ "name" | translate }}:</div>
          <div>{{ vm.profile.fullName }}</div>
        </div>
        @if (!!vm.location.citizenship) {
          <div class="kyc-verification-citizenship">
            <div class="kyc-placeholders">{{ "verification_citizenship_label" | translate }}:</div>
            <div>{{ vm.location.citizenship }}</div>
          </div>
        }
      </div>
      <a
        class="bpi__icon-caret-right collapsible-caret"
        target="_blank"
      (click)="changePersonalInformation(infoUserType.Personal)"></a>
    </div>
    <div class="separator"></div>
    <div class="kyc-verification-address">
      <div class="kyc-verification-content">
        <div class="kyc-verification-section-titles">{{ "address" | translate }}</div>
        <div>
          <span>{{ vm.profile.street }}</span>
          <span>{{ " • " + vm.profile.zipcode + " " }}</span>
          <span>{{ vm.profile.city }}</span>
          @if (!!vm.location.country) {
            <span>{{ " • " + vm.location.country }}</span>
          }
        </div>
      </div>
      <a
        class="bpi__icon-caret-right collapsible-caret"
        target="_blank"
      (click)="changeAddress(infoUserType.Address)"></a>
    </div>
    <div class="separator"></div>
    <div class="kyc-verification-email">
      <div class="kyc-verification-content">
        <div class="kyc-verification-section-titles">{{ "modal_contact_email" | translate }}</div>
        <div>{{ vm.profile.email }}</div>
      </div>
      <a
        class="bpi__icon-caret-right collapsible-caret"
        target="_blank"
      (click)="changeEmailAddress(infoUserType.Email)"></a>
    </div>
    <div class="separator"></div>
    <div class="kyc-verification-phone">
      <div class="kyc-verification-content">
        <div class="kyc-verification-section-titles">{{ "fma_kyc_phone" | translate }}</div>
        <div>{{ vm.profile.mobile }}</div>
      </div>
      <a
        class="bpi__icon-caret-right collapsible-caret"
        target="_blank"
      (click)="changePhoneNumber(infoUserType.Phone)"></a>
    </div>
    <div class="separator"></div>
  </div>
}
